/**
 * The backend refuses purchase endpoints from the store builds with 403 `{"detail": {"error": "web_only"}}`
 * (checkout, billing portal, past-due retry, usage credits, auto-recharge). Companion mode hides every entry
 * point, so this is a backstop: a neutral toast, no crash, no link and no "manage on the web" call to action.
 */
import useToast from '@/composables/useToast'

export const WEB_ONLY_MESSAGE = 'This isn’t available in the app.'

export function isWebOnlyResponse(status: number | undefined, data: unknown): boolean {
    if (status !== 403 || !data || typeof data !== 'object') return false
    const d = data as { detail?: unknown; error?: unknown }
    const detail = d.detail as { error?: unknown } | string | undefined
    if (detail && typeof detail === 'object' && detail.error === 'web_only') return true
    return detail === 'web_only' || d.error === 'web_only'
}

let lastShownAt = 0

/** One toast per burst (several purchase calls can fail together). */
export function notifyWebOnly(now = Date.now()): void {
    if (now - lastShownAt < 4000) return
    lastShownAt = now
    try {
        useToast().showToast({ type: 'info', message: WEB_ONLY_MESSAGE })
    } catch {
        /* no toast host (tests) */
    }
}
